module.exports = __webpack_public_path__ + "img/餐费水单示例.ce60d68d.png";